<template>
  <div>
    <b-card no-body class="mt-3" border-variant="info" header="Info">
      <template v-slot:header>
        <h5 class="mb-0">{{ input.headline }}</h5>
        <div class="cardSubheading" v-if="connect">
          (Zur zeit wird dieser Block nicht im Ergebnis berücksichtigt, um dies
          zu ändern gehen Sie bitte in die Gebühreneinstellungen)
        </div>
      </template>

      <b-list-group flush>
        <!-- row1 -->
        <b-list-group-item variant="light">
          <b-row align-v="center">
            <b-col class="ml--2">
              <span class="mb-0"> AT</span>
            </b-col>
            <b-col md="auto">
              <b-input-group class="input-group-merge">
                <b-form-input
                  type="text"
                  style="text-align:right;"
                  :disabled="true"
                  v-model="row1value"
                  onFocus="this.select()"
                  lazy
                />

                <b-input-group-append is-text>
                  <b-icon :icon="input.row1.icon"></b-icon>
                </b-input-group-append>
              </b-input-group> </b-col></b-row
        ></b-list-group-item>

        <!-- row2 -->
        <b-list-group-item variant="light">
          <b-row align-v="center">
            <b-col class="ml--2">
              <span class="mb-0"> Stunden pro Tag</span>
            </b-col>
            <b-col md="auto">
              <b-input-group class="input-group-merge">
                <b-form-input
                  type="text"
                  min="0"
                  style="text-align:right;"
                  :disabled="true"
                  v-model="row2value"
                  onFocus="this.select()"
                  lazy
                />
                <b-input-group-append is-text>
                  <b-icon :icon="input.row2.icon"></b-icon>
                </b-input-group-append>
              </b-input-group> </b-col></b-row
        ></b-list-group-item>

        <!-- row3 -->
        <b-list-group-item variant="light">
          <b-row align-v="center">
            <b-col class="ml--2">
              <span class="mb-0">
                Stunden Im Monat
              </span>
            </b-col>
            <b-col md="auto">
              <b-input-group class="input-group-merge">
                <b-form-input
                  type="text"
                  min="0"
                  style="text-align:right;"
                  :disabled="true"
                  v-model="row3value"
                  onFocus="this.select()"
                  lazy
                />
                <b-input-group-append is-text>
                  <b-icon :icon="input.row3.icon" />
                </b-input-group-append>
              </b-input-group> </b-col></b-row
        ></b-list-group-item>

        <!-- row4 -->
        <b-list-group-item variant="light">
          <b-row align-v="center">
            <b-col class="ml--2">
              <span class="mb-0">
                Belege pro Stunde
              </span>
            </b-col>
            <b-col md="auto">
              <b-input-group class="input-group-merge">
                <b-form-input
                  type="text"
                  min="0"
                  style="text-align:right;"
                  :disabled="true"
                  v-model="row4value"
                  onFocus="this.select()"
                  lazy
                />

                <b-input-group-append is-text>
                  <b-icon :icon="input.row4.icon"></b-icon>
                </b-input-group-append>
              </b-input-group> </b-col
          ></b-row>
        </b-list-group-item>

        <!-- row5 -->
        <b-list-group-item variant="light">
          <b-row align-v="center">
            <b-col class="ml--2">
              <span class="mb-0"> Arbeitskosten im Monat </span>
            </b-col>
            <b-col md="auto">
              <b-input-group class="input-group-merge">
                <b-form-input
                  type="text"
                  min="0"
                  style="text-align:right;"
                  :disabled="true"
                  v-model="row5value"
                  onFocus="this.select()"
                  lazy
                />

                <b-input-group-append is-text>
                  <b-icon :icon="input.row5.icon"></b-icon>
                </b-input-group-append>
              </b-input-group> </b-col
          ></b-row>
        </b-list-group-item>

        <!-- row6 -->
        <b-list-group-item variant="light">
          <b-row align-v="center">
            <b-col class="ml--2">
              <span class="mb-0"> {{ input.row6.text }} </span>
            </b-col>
            <b-col md="auto">
              <b-input-group class="input-group-merge">
                <b-form-input
                  type="text"
                  min="0"
                  style="text-align:right;"
                  :disabled="true"
                  v-model="row6value"
                  onFocus="this.select()"
                  lazy
                />

                <b-input-group-append is-text>
                  <b-icon :icon="input.row6.icon"></b-icon>
                </b-input-group-append>
              </b-input-group> </b-col
          ></b-row>
        </b-list-group-item>
      </b-list-group>
    </b-card>
  </div>
</template>

<script>
export default {
  name: "InputCardConnect",
  props: ["input", "connect"],
  data() {
    return {
      row1: null
    };
  },
  methods: {
    //Methode die einen Währungsstring in eine normale Number umwandelt (z.B: 1.540,30 € -> 1540.3)
    realParseFloat(s) {
      if (s == "" || s == null) {
        s = "0";
      }
      s = s.replace(/[^\d,.-]/g, ""); // strip everything except numbers, dots, commas and negative sign
      if (
        navigator.language.substring(0, 2) !== "de" &&
        /^-?(?:\d+|\d{1,3}(?:,\d{3})+)(?:\.\d+)?$/.test(s)
      ) {
        // if not in German locale and matches #,###.######
        s = s.replace(/,/g, ""); // strip out commas
        return parseFloat(s); // convert to number
      } else if (/^-?(?:\d+|\d{1,3}(?:\.\d{3})+)(?:,\d+)?$/.test(s)) {
        // either in German locale or not match #,###.###### and now matches #.###,########
        s = s.replace(/\./g, ""); // strip out dots
        s = s.replace(/,/g, "."); // replace comma with dot
        return parseFloat(s);
      } // try #,###.###### anyway
      else {
        s = s.replace(/,/g, ""); // strip out commas
        return parseFloat(s); // convert to number
      }
    },
    rowFormating(rowFormat, stateObj) {
      if (rowFormat == "currency") {
        //formatiert ins local Währungsformat inkl€
        return stateObj.toLocaleString("de-DE", {
          style: "currency",
          currency: "EUR"
        });
      } else if (rowFormat == "time") {
        //TODO falls es ander formatierungen geben soll
        return stateObj + " Minuten";
      } else if (!rowFormat) {
        //formatiert in lokale Dezimalschreibweise (. -> ,)
        return stateObj.toLocaleString("de-DE");
      }
    },
    gettersToLocaleCurrency(value) {
      return this.$store.getters[value].toLocaleString("de-DE", {
        style: "currency",
        currency: "EUR"
      });
    }
  },
  computed: {
    row1value() {
      return this.rowFormating(
        null,
        this.$store.getters[this.input.row1.value]
      );
    },
    row2value() {
      return this.rowFormating(
        null,
        this.$store.getters[this.input.row2.value]
      );
    },
    row3value() {
      return this.rowFormating(
        null,
        this.$store.getters[this.input.row3.value]
      );
    },
    row4value() {
      return this.rowFormating(
        null,
        this.$store.getters[this.input.row4.value]
      );
    },
    row5value() {
      return this.gettersToLocaleCurrency(this.input.row5.value);
    },
    row6value() {
      return this.gettersToLocaleCurrency(this.input.row6.value);
    }
  }
};
</script>
